export const primary = "#1e56a0";
export const secondary = "#7149C6";
export const accent = "#163172";
export const background = "#fef9ef";
